
import { updateAppConfig } from '#app/config'
import { defuFn } from 'defu'

const inlineConfig = {
  "nuxt": {
    "buildId": "f5115f58-7ede-4f7a-b081-a8b896fbf8cb"
  }
}

// Vite - webpack is handled directly in #app/config
if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    updateAppConfig(newModule.default)
  })
}

import cfg0 from "/builds/projectowners/lawofficesystem/app.config.ts"

export default /* #__PURE__ */ defuFn(cfg0, inlineConfig)
